import styled from 'styled-components';

import colors from 'styles/colors';

export const SubmissionsListStyled = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-shrink: 0;
  padding: 16px;
  width: 340px;
  height: 100dvh;
  min-height: 0;
  border-right: 1px solid ${colors.black_shadow};
  overflow: hidden;
`;

export const SubmissionsListContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  flex: 1;
  width: 100%;
  min-height: 0;
  overflow-y: auto;
  box-sizing: border-box;

  > div {
    width: 100%;
  }
`;

export const SubmissionsSentinelStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 12px;
  color: ${colors.gray_scale10};
  font-size: 14px;
  box-sizing: border-box;
`;

export const SubmissionsSentinelErrorStyled = styled(SubmissionsSentinelStyled)`
  flex-direction: column;
  color: ${colors.error_scale2};
`;

export const SubmissionsSentinelRetryStyled = styled.button`
  background: none;
  border: none;
  color: ${colors.brand_2};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 8px;

  &:hover {
    text-decoration: underline;
  }
`;
